<script lang="ts">
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';
    import type {ProjectFinancialOverviewResponse} from 'src/features/erp-sutor/features/project-financial-overview/types';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import KpPrice from 'shared/components/kp-price/KpPrice.svelte';

    export let projectFinancialOverview: ProjectFinancialOverviewResponse;
    export let index: number;

    const rootProject = index === 0;
</script>

<tr class="financial-overview-project-item">
    <td>
        <div class="project-column">
            <div class="project-info" class:root-project={rootProject}>
                <div class="name-container">
                    <span class="name">{pipe(projectFinancialOverview.projectRecord, loc())}</span>
                    <KpChipTag chipSize="xs" chipStyle="success">Zahájeno</KpChipTag>
                </div>
                <span class="description">Testovací popis</span>
                <span class="price">Smluvní cena: <span class="price-value">10 000 CZK</span></span>
            </div>
        </div>
    </td>

    <td>
        <div class="data-column headings">
            <div class="data-cell">Vlastní</div>
            <div class="data-cell">Pendleři</div>
            <div class="data-cell">Cizí</div>
            <div class="data-cell">Celkem</div>
        </div>
    </td>

    {#each [
        projectFinancialOverview.reportedWorkActivityCosts,
        projectFinancialOverview.reportedOperatedMachineCosts,
        projectFinancialOverview.reportedMachineCosts,
        projectFinancialOverview.reportedWorkCompletionCosts,
        projectFinancialOverview.reportedMaterialCosts,
        projectFinancialOverview.reportedSubsupplierCosts,
        projectFinancialOverview.reportedRechargedCosts
    ] as costs}
        <td>
            <div class="data-column green-highlight">
                <div class="data-cell"><KpPrice price={costs.projectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.otherDivisionLoaned}/></div>
                <div class="data-cell"><KpPrice price={costs.subprojectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.total}/></div>
            </div>
        </td>
    {/each}

    {#each [
        projectFinancialOverview.materialAccountingJournalCosts,
        projectFinancialOverview.subsupplierAccountingJournalCosts,
        projectFinancialOverview.otherAccountingJournalCosts
    ] as costs}
        <td>
            <div class="data-column blue-highlight">
                <div class="data-cell"><KpPrice price={costs.projectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.otherDivisionLoaned}/></div>
                <div class="data-cell"><KpPrice price={costs.subprojectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.total}/></div>
            </div>
        </td>
    {/each}

    <!-- overall planned costs -->
    {#each [projectFinancialOverview.overallPlannedCosts] as costs}
        <td>
            <div class="data-column all-highlighted">
                <div class="data-cell"><KpPrice price={costs.projectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.otherDivisionLoaned}/></div>
                <div class="data-cell"><KpPrice price={costs.subprojectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.total}/></div>
            </div>
        </td>
    {/each}

    <!-- overall planned revenues -->
    {#each [projectFinancialOverview.overallPlannedRevenues] as revenues}
        <td>
            <div class="data-column all-highlighted">
                <div class="data-cell"></div>
                <div class="data-cell"></div>
                <div class="data-cell"></div>
                <div class="data-cell yellow-highlight"><KpPrice price={revenues.total}/></div>
            </div>
        </td>
    {/each}

    <!-- planned profit -->
    <td>
        <div class="data-column all-highlighted">
            <div class="data-cell"></div>
            <div class="data-cell"></div>
            <div class="data-cell"></div>
            <div class="data-cell red-highlight"><KpPrice price={{amount: projectFinancialOverview.overallPlannedRevenues.total.amount - projectFinancialOverview.overallPlannedCosts.total.amount, currency: projectFinancialOverview.overallPlannedRevenues.total.currency}}/></div>
        </div>
    </td>

    <!-- overall real costs -->
    {#each [projectFinancialOverview.overallRealCosts] as costs}
        <td>
            <div class="data-column all-highlighted">
                <div class="data-cell"><KpPrice price={costs.projectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.otherDivisionLoaned}/></div>
                <div class="data-cell"><KpPrice price={costs.subprojectDivisionOwned}/></div>
                <div class="data-cell"><KpPrice price={costs.total}/></div>
            </div>
        </td>
    {/each}

    <!-- overall real revenues -->
    {#each [projectFinancialOverview.overallRealRevenues] as revenues}
        <td>
            <div class="data-column all-highlighted">
                <div class="data-cell"></div>
                <div class="data-cell"></div>
                <div class="data-cell"></div>
                <div class="data-cell yellow-highlight"><KpPrice price={revenues.total}/></div>
            </div>
        </td>
    {/each}

    <!-- real profit -->
    <td>
        <div class="data-column all-highlighted">
            <div class="data-cell"></div>
            <div class="data-cell"></div>
            <div class="data-cell"></div>
            <div class="data-cell red-highlight"><KpPrice price={{amount: projectFinancialOverview.overallRealRevenues.total.amount - projectFinancialOverview.overallRealCosts.total.amount, currency: projectFinancialOverview.overallRealRevenues.total.currency}}/></div>
        </div>
    </td>
</tr>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .data-column {
        display: inline-flex;
        flex-direction: column;
        width: 100%;
        gap: @spacing-xs;

        .data-cell {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: @spacing-sm;
            height: 24px;
        }

        .data-cell:last-child {
            font-weight: 500;
        }

        &.headings {
            color: @themed-text-muted;
        }

        &.all-highlighted .data-cell {
            font-weight: 500;
        }
    }

    .project-column {
        display: inline-flex;
        align-items: center;
        gap: @spacing-l;

        .project-info {
            display: flex;
            flex-direction: column;
            gap: @spacing-xs;

            --project-color: var(--accent-blue);

            &.root-project {
                --project-color: var(--brand-orange);
            }

            .name-container {
                display: flex;
                align-items: center;
                gap: @spacing-s;

                .name {
                    font-size: @font-size-default;
                    font-weight: 500;
                    color: var(--project-color);
                }
            }

            .description {
                color: @themed-text-muted;
            }

            .price {
                color: @themed-text-muted;

                .price-value {
                    font-weight: 500;
                    color: @themed-text-default;
                }
            }
        }
    }

    .green-highlight {
        background-color: #ddf3e3;
        border-radius: @border-radius-default;
    }

    .blue-highlight {
        background-color: @themed-body-bg-blue-highlighted;
        border-radius: @border-radius-default;
    }

    .yellow-highlight {
        background-color: #FFF2D3;
        border-radius: @border-radius-default;
    }

    .red-highlight {
        background-color: #f6dcdf;
        border-radius: @border-radius-default;
    }
</style>